export enum ModelFormatTypeEnum {
    CSV = 1,
    FLOW_DIAGRAM = 2,
    WEB_LINK = 3
};